import { getPathAPI, getAuthHeaders, triggerBlobDownload } from "@/helpers";
import axios, { AxiosResponse } from "axios";
import BaseCollectionService from "./base.collection.service";

class AdjusterfileService extends BaseCollectionService {
  constructor() {
    super("adjuster");
  }
  public async exportAdjusterFile(payload: any): Promise<AxiosResponse> {
    const path = `/adjuster/file/view`;
    const response = await axios({
      url: `${getPathAPI()}${path}`,
      method: "GET",
      responseType: "blob",
      params: {
        adjusterCode: payload.adjusterCode,
        fileName: payload.fileName
      },
      headers: getAuthHeaders()
    });
    triggerBlobDownload(response.data, `${payload.fileName}`);
    return response;
  }
}

export default new AdjusterfileService();
